/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/nlp-integration-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/nlp-integration-api-client";
import type { QueryTopicsLiveTopicsQueryResponse, QueryTopicsLiveTopicsPathParams, QueryTopicsLiveTopicsQueryParams } from "../models/QueryTopicsLiveTopics";

export function getQueryTopicsLiveTopicsUrl(slug: QueryTopicsLiveTopicsPathParams["slug"]) {
  const res = { method: 'GET', url: `/live-topics/${slug}/topics` as const }
  return res
}

/**
 * @description Query topics by start time for timeline views.
 * @summary Query topics by time range
 * {@link /live-topics/:slug/topics}
 */
export async function queryTopicsLiveTopics(slug: QueryTopicsLiveTopicsPathParams["slug"], params?: QueryTopicsLiveTopicsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<QueryTopicsLiveTopicsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getQueryTopicsLiveTopicsUrl(slug).url.toString(), params, ... requestConfig })
  return res.data
}